<template>
  <div class="preview">
    <div class="inner">
      <div class="preview__header">
        <div class="info">
          <h2>{{ title }}</h2>
          <div class="detail">
            <span>{{ previewAmount }}次浏览</span> | <span>{{ downloadAmount }}次下载</span>
          </div>
        </div>
        <Dropdown trigger="click">
          <VuiButton :class="['btn', {'disable': !isBindAlpha && isLogin}]" type="warning" round @click="clickBtnHanlder($event)">
            <Icon type="md-lock" />
            立即下载
          </VuiButton>
          <template #list>
            <DropdownMenu>
              <DropdownItem v-for="item in downloadList" :key="item.id" @click.native="clickExpandHandler(item)">{{ item.name }}</DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
      </div>
      <div class="preview__authors">
        <div v-for="author in authors" :key="author.id" class="preview__author">
          <img class="author__avatar" :src="author.authorAvatar" alt="">
          <div class="author__name">{{ author.authorName }}</div>
          <div class="author__office">{{ author.lawName }}</div>
        </div>
      </div>
      <div class="preview__pdf">
        <iframe ref="pdf" :src="previewUrl" frameborder="0" @load="pdfLoadHandler"></iframe>
        <div ref="toolbar" class="preview__toolbar">
          <div class="toolbar__page">
            <Icon type="ios-arrow-back" :class="{'disabled': curPage === 1}" @click="prevPage" />
            <div class="toolbar__page-cur">
              <input v-model.number="curPage" type="text" @keyup.enter="skipToPage" @blur="skipToPage">
            </div>
            <span>/</span>
            <div class="toolbar__page-total">{{ totalPage }}</div>
            <Icon type="ios-arrow-forward" :class="{'disabled': curPage === totalPage}" @click="nextPage" />
          </div>
          <div class="toolbar__line"></div>
          <div class="toolbar__zoom">
            <img src="/img/zoom-add.png" alt="" @click="zoom('add')">
            <img src="/img/zoom-minus.png" alt="" @click="zoom('minus')">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/home.js'
export default {
  name: 'ExpandPreview',
  data () {
    return {
      title: '',
      previewAmount: 0,
      downloadAmount: 0,
      downloadList: [],
      authors: [],
      previewUrl: '',
      curPage: 1,
      totalPage: 1,
      pdfWin: null,
    }
  },
  computed: {
    ...mapState('app', ['isLogin', 'isBindAlpha']),
  },
  methods: {
    async getCoursewareDetail (id) {
      const data = await api.getExpandCourseware(id)()
      this.downloadList = data.marketExpansionCoursesDTOS
      this.title = data.name
      this.previewAmount = data.countView
      this.downloadAmount = data.countDownload
      this.authors = data.authorInfo
      this.previewUrl = window.origin + `/pdf/pdf-viewer/viewer.html?url=${data.pdfUrl}`
    },
    clickBtnHanlder (e) {
      if (!this.isBindAlpha && this.isLogin) {
        e.stopPropagation()
      }
    },
    clickExpandHandler (item) {
      if (this.isLogin) {
        if (item.fileUrl) {
          api.downloadExpand(item.id)().then(res => {
            if (res) {
              let file = JSON.parse(item.fileUrl)
              let a = document.createElement('a')
              a.href = file.fileUrl
              a.download = file.fileName
              a.click()
            }
          })
        } else {
          this.$Message.error('暂无可下载的地址')
        }
      } else {
        this.$Message.error('请先登录')
        this.$router.push({ name: 'Login' })
      }
    },
    pdfLoadHandler () {
      this.pdfWin = this.$refs.pdf.contentWindow
      if (this.pdfWin && this.pdfWin.PDFViewerApplicationOptions) {
        this.pdfWin.PDFViewerApplicationOptions.set('defaultZoomValue', '100%')
      }
      if (this.pdfWin && this.pdfWin.PDFViewerApplication) {
        let pdfInstance = this.pdfWin.PDFViewerApplication
        let timer = setInterval(() => {
          if (pdfInstance.isInitialViewSet) {
            clearInterval(timer)
            this.pdfjsLoadedHandler(pdfInstance)
          }
        })
      }
    },
    pdfjsLoadedHandler (instance) {
      this.curPage = instance.page
      this.totalPage = instance.pagesCount
      console.log(instance, this.totalPage)
      instance.eventBus.on('pagechanging', (e) => {
        this.curPage = e.pageNumber
      })
    },
    prevPage () {
      this.curPage--
      this.skipToPage()
    },
    nextPage () {
      this.curPage++
      this.skipToPage()
    },
    skipToPage () {
      this.curPage = Math.min(Math.max(1, this.curPage), this.totalPage)
      this.pdfWin.PDFViewerApplication.page = this.curPage
    },
    zoom (op) {
      if (op === 'add') {
        this.pdfWin.PDFViewerApplication.zoomIn()
      } else if (op === 'minus') {
        this.pdfWin.PDFViewerApplication.zoomOut()
      }
    },
    observeFooter () {
      this.ob = new IntersectionObserver((entries) => {
        let footer = entries[0]
        if (footer.isIntersecting) {
          this.$refs.toolbar.classList.add('large-bottom')
        } else {
          this.$refs.toolbar.classList.remove('large-bottom')
        }
      })
      this.ob.observe(document.querySelector('#app > footer'))
    },
  },
  mounted () {
    if (this.$route.params.id) {
      this.getCoursewareDetail(this.$route.params.id)
    }

    this.observeFooter()
  },
  beforeDestroy () {
    this.ob.disconnect()
  },
}
</script>

<style lang="scss" scoped>
.preview {
  width: 100%;
  background-color: #fff;
  border-top: 1px solid transparent;
  .inner {
    width: 1000px;
    height: 100%;
    margin-inline: auto;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
    margin-top: 40px;
    .info {
      h2 {
        max-width: 810px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 34px;
        margin-bottom: 8px;
      }
      .detail {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, .3);
        line-height: 18px;
      }
    }
    &:deep(.vui-btn) {
      background: #FA8919;
      border-radius: 16px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      border: none;
      position: relative;
      top: 2px;
      .ivu-icon-md-lock {
        display: none;
      }
      &.disable {
        cursor: not-allowed;
        background: #707070;
        border: 1px solid #707070;
        .ivu-icon-md-lock {
          display: inline;
        }
        &:hover {
          background: #707070;
        }
      }
      &:hover {
        background: #FA9A2A;
      }
    }
    &:deep(.ivu-icon.ivu-icon-md-lock) {
      position: relative;
      top: -1px;
      margin-right: 4px;
    }
  }
  &__authors {
    display: flex;
    margin-bottom: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__author {
    position: relative;
    display: flex;
    align-items: center;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .author {
      &__avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
      }
      &__name {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        margin-inline: 16px 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &__office {
        font-size: 13px;
        color: rgba(51, 51, 51, .3);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &:not(:last-of-type){
      padding-right: 24px;
      margin-right: 24px;
      &::after {
        content: "";
        position: absolute;
        width: 1px;
        height: 12px;
        right: 0;
        background: #C1C1C1;
      }
    }
  }
  &__pdf {
    position: relative;
    height: 100vh;
    width: 100%;
    iframe {
      width: 100%;
      height: 100%;
    }
    &:hover {
      .preview__toolbar {
        opacity: 0.6;
      }
    }
  }
  &__toolbar {
    position: fixed;
    display: flex;
    align-items: center;
    height: 40px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 64px;
    padding-inline:  19px;
    line-height: 40px;
    opacity: 0;
    transition: opacity .3s ease-in;
    background: #000000;
    border-radius: 4px;
    box-sizing: border-box;
    .toolbar {
      &__page {
        display: flex;
        align-items: center;
        font-size: 16px;;
        color: #FFFFFF;
        font-family: PingFangSC-Regular, PingFang SC;
        .ivu-icon {
          font-size: 14px;
          cursor: pointer;
          &.disabled {
            color: rgba(255, 255, 255, .6);
            cursor: not-allowed;
          }
        }
        input {
          margin-left: 8px;
          width: 48px;
          height: 24px;
          background: rgba(255, 255, 255, .08);
          border-radius: 2px;
          color: #FFFFFF;
          outline: none;
          border: none;
          text-align: center;
          font-size: 16px;
          font-weight: 400;
          color: #FFFFFF;
        }
        span {
          margin-inline: 8px;
        }
        &-total {
          margin-right: 15px;
        }
      }
      &__line {
        width: 1px;
        height: 24px;
        background: #FFFFFF;
        opacity: 0.1;
        margin-inline: 19px;
      }
      &__zoom {
        display: flex;
        img {
          width: 18px;
          height: 18px;
          cursor: pointer;
          & + img {
            margin-left: 20px;
          }
        }
      }
    }
    &.large-bottom {
      bottom: 264px;
    }
  }
}
</style>
